// removed by extract-text-webpack-plugin
module.exports = {"keyboard":"J9SA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/keyboard/index.less
// module id = 266
// module chunks = 0